/**
 * @fileoverview Input/output schemas for world-event-snapshotter-v3.
 *
 * This agent updates a world event's state after a chapter has been written.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { WorldEventAttributesV3Schema, WorldEventSnapshotV3Schema } from '@/domains/world-building/schemas';

export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  worldEvent: z.object({
    id: z.string(),
    name: z.string(),
    type: z.literal('event'),
    element: z.enum(['historical-event', 'prophecy', 'legend']),
    initialDescription: z.string().optional(),
  }).describe('The world event being snapshotted.'),
  previousSnapshot: WorldEventSnapshotV3Schema.optional().describe('The event state before this chapter.'),
  chapterContent: z.string().describe('The full content of the chapter to analyze.'),
  chapterNumber: z.number().describe('The chapter number for snapshot metadata.'),
});

export type Input = z.infer<typeof InputSchema>;

export const OutputSchema = WorldEventAttributesV3Schema.extend({
  notPresentInChapter: z.boolean().optional().describe('True if the event was not mentioned or relevant in this chapter.'),
});

export type Output = z.infer<typeof OutputSchema>;
